import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';

export function setupQueryPersistence(queryClient: QueryClient) {
    const persister = createSyncStoragePersister({
        storage: window.localStorage,
        key: 'MFOUR_STUDIO_CACHE', // Unique key for our app
        throttleTime: 1000, // Save to storage at most once per second
        serialize: (data) => JSON.stringify(data),
        deserialize: (data) => JSON.parse(data),
    });

    persistQueryClient({
        queryClient,
        persister,
        maxAge: 1000 * 60 * 60 * 24, // 24 hours
        buster: process.env.NEXT_PUBLIC_APP_VERSION, // Cache buster
        dehydrateOptions: {
            shouldDehydrateQuery: (query) => {
                // Only persist certain queries
                const persistableQueries = ['filters', 'questions', 'questionAggregation'];
                return persistableQueries.some((key) => query.queryKey.includes(key));
            },
        },
    });
}
